export default __webpack_public_path__ + "static/v2_ovidiu_bw-ac5202238bc15e108a0d3cf8cf4ecec3.jpg";